var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6666667,12.8333333 C20.6033333,12.8333333 22.155,11.27 22.155,9.33333333 C22.155,7.39666667 20.6033333,5.83333333 18.6666667,5.83333333 C16.73,5.83333333 15.1666667,7.39666667 15.1666667,9.33333333 C15.1666667,11.27 16.73,12.8333333 18.6666667,12.8333333 L18.6666667,12.8333333 L18.6666667,12.8333333 Z M9.33333333,12.8333333 C11.27,12.8333333 12.8216667,11.27 12.8216667,9.33333333 C12.8216667,7.39666667 11.27,5.83333333 9.33333333,5.83333333 C7.39666667,5.83333333 5.83333333,7.39666667 5.83333333,9.33333333 C5.83333333,11.27 7.39666667,12.8333333 9.33333333,12.8333333 L9.33333333,12.8333333 L9.33333333,12.8333333 Z M9.33333333,15.1666667 C6.615,15.1666667 1.16666667,16.5316667 1.16666667,19.25 L1.16666667,22.1666667 L17.5,22.1666667 L17.5,19.25 C17.5,16.5316667 12.0516667,15.1666667 9.33333333,15.1666667 L9.33333333,15.1666667 L9.33333333,15.1666667 Z M18.6666667,15.1666667 C18.3283333,15.1666667 17.9433333,15.19 17.535,15.225 C18.8883333,16.205 19.8333333,17.5233333 19.8333333,19.25 L19.8333333,22.1666667 L26.8333333,22.1666667 L26.8333333,19.25 C26.8333333,16.5316667 21.385,15.1666667 18.6666667,15.1666667 L18.6666667,15.1666667 L18.6666667,15.1666667 Z",
    id: "path",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9d5a6133b57880584a350261a1491ae0.svg";
export { ForwardRef as ReactComponent };